import { defaultEarnMessage } from 'src/assets/RewardsConfig'
import { AnalyticsMetricType } from './analytics'

export type RewardsType = {
  rewardsRuleMap: {
    orderPlaced: RewardsRuleType
    referral: RewardsRuleType
    redemption: RewardsRuleType
  }
  currency: CurrencyType
  confirmationStrategyConfig: {
    stratagyType: ConfirmationStratagyType
    durationAfter: number
  }
  createdBy: string
  isActive: boolean
  roundingOffStartagy: RoundingOffStratagyType
  coinName: string
  coinNamePlural: string
}
export type RewardsRuleType = {
  action: RewardsRuleActionType
  earnBurnType: EarnBurnType
  amount: number
  expiry: number
}
export type RewardsRuleActionType = 'EARN' | 'BURN'
export type EarnBurnType = 'RATIO' | 'FIXED'
export type CurrencyType = 'INR'
export type ConfirmationStratagyType = 'INSTANT' | 'DELAYED'
export type RoundingOffStratagyType = 'ROUND_DOWN'

export interface EarnConfigType {
  earnRatio?: number
  delay?: number | null
  expiry?: number | null
}

export interface BurnConfigType {
  burnRatio?: number
}

export interface BurnConditionsConfigType {
  min_ov: number
}

export interface EarnBurnRewardsPayloadType {
  event_reward_rule_map?: {
    ORDER_PLACED?: {
      earn_burn_type: 'RATIO' | 'FIXED'
      action: 'EARN'
      amount?: number
      max_amount?: number
      expiry_time?: number | null
    }
    REDEMPTION?: {
      earn_burn_type: 'FIXED' | 'RATIO'
      action: 'BURN'
      amount?: number
      max_amount?: number
      expiry_time?: number | null
      block_for_cod?: false
    }
  }
  currency: 'INR'
  order_type_confirmation_strategies?: {
    COD?: {
      type: 'INSTANT' | 'DELAYED'
      duration_after: number
    }
    ONLINE?: {
      type: 'INSTANT' | 'DELAYED'
      duration_after: number
    }
  }
}

export type BlockingConditions = {
  type: 'MIN_CART_VALUE' | 'BLOCKED_PRODUCTS' | 'BLOCKED_VARIANTS'
  value: any
}

export interface EarnRewardsConditionPayloadType {
  event_reward_rule_map: {
    ORDER_PLACED: {
      blocking_conditions: BlockingConditions[]
    }
  }
}

export interface BurnRewardsConditionPayloadType {
  event_reward_rule_map: {
    REDEMPTION: {
      blocking_conditions: BlockingConditions[]
    }
  }
}

export interface CreditNameType {
  singularName: string
  pluralName: string
}

export interface EarnMessageType {
  enable: boolean
  line_1: string
  line_2: string
}

export interface EarnTileCustomiseUiType {
  textColor: string
  outlineColor: string
  backgroundColor: string
  isCreditNameVisible: string
  outline: string
}

export interface CreditNameUpdatePayloadType {
  coin_name: string
  coin_name_plural: string
}

export interface ToggleRewardsType {
  active: boolean
}

export interface RewardsConfigType {
  creditName: CreditNameType
  earnMessage: EarnMessageType
  earnTileCustomiseUi: EarnTileCustomiseUiType
}

export const defaultRewardsConfig: RewardsConfigType = {
  creditName: {
    singularName: 'Store Credit',
    pluralName: 'Store Credits'
  },
  earnMessage: defaultEarnMessage,
  earnTileCustomiseUi: {
    textColor: '#2C874A',
    outlineColor: '#96C3A4',
    backgroundColor: '#EAF3ED',
    isCreditNameVisible: 'block',
    outline: 'dashed'
  }
}
export interface RewardsContextType {
  state: RewardsConfigType
  actions: {
    setCreditName: (creditName: CreditNameType) => void
    setEarnMessage: (earnMessage: EarnMessageType) => void
    setEarnTileCustomisation: (earnTileCustomisation: EarnTileCustomiseUiType) => void
    setDiscardChanges: (rewardsConfig: RewardsConfigType) => void
    setSaveChanges: (rewardsConfig: RewardsConfigType) => void
  }
  initialRewardsConfig: RewardsConfigType
}

export const rewardsPayload = (rewardsConfig: RewardsConfigType) => {
  return {
    coin_name: rewardsConfig?.creditName?.singularName,
    coin_name_plural: rewardsConfig?.creditName?.pluralName,
    personalized_wallet_display_message_enabled: rewardsConfig?.earnMessage?.enable,
    rewards_earned_message: rewardsConfig?.earnMessage?.line_1.replace('<Rewards_value>', '<rewards_value>'),
    currency_earned_message: rewardsConfig?.earnMessage?.line_2.replace('<Rupees_value>', '<currency_value>'),
    earn_tile_customise_ui: {
      text_color: rewardsConfig?.earnTileCustomiseUi?.textColor,
      outline_color: rewardsConfig?.earnTileCustomiseUi?.outlineColor,
      background_color: rewardsConfig?.earnTileCustomiseUi?.backgroundColor,
      is_credit_name_visible: rewardsConfig?.earnTileCustomiseUi?.isCreditNameVisible,
      outline: rewardsConfig?.earnTileCustomiseUi?.outline
    }
  }
}
export type RewardAnalyticsWidgetType = {
  id: string
  positionX: number
  positionY: number
  title: string
  primaryMetric?: AnalyticsMetricType
  secondaryMetricsList?: Array<AnalyticsMetricType>
  detailedMetricsList?: Array<Array<AnalyticsMetricType>>
}
